import { fetchData } from './fetch-data.js';

export class EtService {
  public async publish(endpoint: 'routings' | 'redirects'): Promise<void> {
    const response = await fetchData(`/et/${endpoint}`, {
      method: 'POST'
    });

    if (response.status < 200 || response.status >= 400) {
      throw new Error(`Die Veröffentlichung von '${endpoint}' konnte nicht ausgeführt werden`);
    }
  }
}
